import React from 'react';
import styled from 'styled-components';
import { Button, Form, Textarea, Divider, token } from '@bynder/design-system';
import { IconSparkles } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

type TranscriptFormProps = {
    srtContent: string;
    isGenerating: boolean;
    onGenerate: () => void;
};

const TranscriptForm = ({ srtContent, isGenerating, onGenerate }: TranscriptFormProps) => {
    const { translate } = useTranslate();

    return (
        <Container>
            <Form>
                <StyledFormGroup>
                    <Button
                        icon={<IconSparkles />}
                        variant="secondary"
                        onClick={onGenerate}
                        isDisabled={isGenerating}
                        isFullWidth
                    >
                        {isGenerating
                            ? translate('editor.transcript.generate-button.generating')
                            : translate('editor.transcript.generate-button')}
                    </Button>
                </StyledFormGroup>
                <StyledDivider />
                <StyledTextarea
                    value={srtContent}
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onChange={() => {}}
                    placeholder={translate('editor.transcript.textarea.placeholder')}
                    aria-label={translate('editor.transcript.title')}
                    isReadOnly
                />
            </Form>
        </Container>
    );
};

const StyledFormGroup = styled(Form.Group)`
    padding: ${token.spacing2};
`;

const StyledDivider = styled(Divider)`
    padding: 0;
`;

const StyledTextarea = styled(Textarea)`
    min-height: 448px;
`;

const Container = styled.div`
    border: 1px solid ${token.gray100};
    border-radius: ${token.brandRadiusBase};
    margin-bottom: ${token.spacing3};

    ${StyledTextarea} {
        border: none;
        &:focus,
        &:hover {
            box-shadow: none;
        }
    }
`;

export default TranscriptForm;
